<template>
	<div>



		<!-- 组件使用 -->
		<cart-list ref="userID" :cart="cart_list" @cartChanged="reflushCount" />

		<div class='cart-bottom'>
			<div class='cart-payment' @click="toSubmit()">结算</div>
			<div class='cart-paytext'>已选择 {{count.num}} 件商品 合计: <span style="color: #ff9d8f;">￥{{count.sum}}</span>
			</div>
		</div>

		<!-- 组件使用 -->
		<syalert ref="syalert_id" />

		<!-- 组件使用 -->
		<foot />

	</div>
</template>
<style>
	.cart-bottom {
		width: 100%;
		height: 3rem;

		position: fixed;
		bottom: 3.4rem;

		/* border: 1px solid blue; */
		background-color: #ffffff;
	}

	.cart-paytext {
		float: right;

		margin: 0.5rem 0;

		font-size: .7rem;
		color: black;
		text-align: right;

		height: 2rem;

		line-height: 2rem;
	}

	.cart-payment {
		float: right;

		margin: 0.5rem 0.5rem;

		font-size: .7rem;
		color: white;
		text-align: center;

		height: 2rem;
		width: 6rem;
		border-radius: 2rem;

		line-height: 2rem;

		background-color: #d9001b;
	}
</style>
<script>
	// 组件引入
	import sy from "@/sy";
	import foot from '@/components/foot.vue';
	import cartList from '@/components/cartList.vue';
	import syalert from '@/components/syalert.vue';

	export default {
		name: 'cart',
		components: {
			foot,
			cartList,
			syalert,
		},
		data() {
			return {
				cart_list: [],

				// ---- ---- 分页参数
				page: {
					on: true, // true|false 开关
					page: 0,
				},
				count: {
					num: 0,
					sum: '0.00',
					arr: [],
				},
			}
		},
		methods: {
			reflushCount: function() {
				// 复位数据
				this.count.num = 0;
				this.count.sum = 0;
				this.count.arr = [];
				for (let x of this.cart_list) {
					if (x.cart_checked === '1') {
						this.count.num++;
						this.count.sum += parseFloat(x.goods_price) * x.cart_num;
						this.count.arr.push(x.cart_id);
					}
				}

				// 这里就不管精度了 只管展示
				// 格式化数字
				this.count.sum = this.count.sum.toFixed(2);
			},
			toSubmit: function() {
				let ids = this.count.arr.toString();
				// console.log(ids);
				// console.log(ids.length);
				if (ids.length === 0) {

					this.$refs.syalert_id.syalert('请选择商品', 3000);
					//console.log('啥也没有');
					return false;
				}

				this.$router.push('/order/submit?ids=' + ids);
			},

			// 复位加载
			initPage: function() {
				this.page = {
					on: true, // 可以获取 信息
					page: 0,
				};
				// this.user = [];  、、这个具体看项目
				this.getList();
			},
			getList: function() {
				// 判断是否获取数据
				if (this.page.on === false) {
					return false;
				}

				this.page.on = false;
				this.page.page++;
				console.log('页数:', this.page.page);

				// 实例重命名
				let $_this = this;
				sy.http.get({
					url: this.$root.API + 'Cart/Get',
					data: {
						page: this.page.page,
					},
					success: function(res) {
						$_this.page.on = true;
 
						if (res.state == '1')
						{
							let data = res.data
							let i = 0;
							for (let k in data)
							{
								i++;
								$_this.cart_list.push(data[k]);
							}
							if (i < 10)
							{
								$_this.page.on = false; // 数量不足时也关掉
							}
						}
					}
				});
			},
			// 监听改写 暂时无法 因为离开时还是 调用了这个
			// 下滑时 触发数据拉取
			scroll_event: function() {
				if (document.getElementsByClassName("scroll-list").length > 0) {
					// 相当于剩余高度
					let uh = document.getElementsByClassName("scroll-list")[0].clientHeight;
					if (uh - window.scrollY - window.innerHeight < 20) {
						this.getList();
					}
				}
			},


		},
		created() {},

		// 进入时候
		activated() {
			sy.log('[页面]-> ' + this.$route.name);

			// 启动监听滑动
			console.log('启动监听滑动');

			// 监听滚动
			window.addEventListener("scroll", this.scroll_event);

			// 初次加载
			if (this.page.page === 0) {
				console.log('初次加载');
				this.initPage();
			}
		},
		// 离开时候
		deactivated() {
			// 销毁监听滑动
			console.log('销毁监听滑动')
			window.removeEventListener("scroll", this.scroll_event);
		}
	}
</script>